/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import PostGroupProvider from 'app/redux/Providers/PostGroupProvider.jsx';
import { compose } from 'redux';
import Loading from 'app/components/common/Loading.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import SocialSelection from 'app/components/SocialModal/SocialSelection.jsx';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import * as _ from 'underscore';
import Utilities from 'app/utility/Utilities.js';
import UserMessages from 'app/modules/UserMessageModule.js';

class PostingGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'new',
            newGroup: {
                name: '',
                group: []
            },
            editGroup: {
                id: 0,
                group: [],
                name: ''
            },
            loading: true,
            apiErrors: null,
            validationErrors: null
        };

        this.createGroup = this.createGroup.bind(this);
        this.editGroup = this.editGroup.bind(this);
        this.validateGroup = this.validateGroup.bind(this);
        this.confirmGroupEdit = this.confirmGroupEdit.bind(this);
        this.deleteGroup = this.deleteGroup.bind(this);
        this.cancelEdits = this.cancelEdits.bind(this);
        this.onSocialClick = this.onSocialClick.bind(this);
        this.filterCallback = this.filterCallback.bind(this);
        this.searchCallback = this.searchCallback.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let errors = props.getApiErrors(['POSTGROUP_LIST', 'POSTGROUP_CREATE', 'POSTGROUP_DELETE', 'POSTGROUP_UPDATE']);

        if (errors.length) {
            return {
                errors: errors
            };
        }

        return {
            errors: null
        };

    }

    componentDidMount() {

        if (!this.props.app.firstLoad.SOCIAL_LIST) {
            this.props.getSocials();
        }

        this.props.getPostGroups();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.app.loading.POSTGROUP_LIST === true && this.props.app.loading.POSTGROUP_LIST === false) {
            this.setState({
                loading: false
            });
        }

        if (prevProps.app.loading.POSTGROUP_CREATE === true && this.props.app.loading.POSTGROUP_CREATE === false) {
            this.props.addMessage(UserMessages.generateFlashMessage("We've created your Posting Group", "POSTGROUP_UPDATE"));
            if (!this.state.errors) {
                this.setState({
                    newGroup: {
                        name: '',
                        group: []
                    }
                });
            }
        }

        if (prevProps.app.loading.POSTGROUP_UPDATE === true && this.props.app.loading.POSTGROUP_UPDATE === false) {
            this.props.addMessage(UserMessages.generateFlashMessage("We've updated your Posting Group", "POSTGROUP_UPDATE"));
            if (!this.state.errors) {
                this.setState({
                    editGroup: {
                        id: 0,
                        name: '',
                        group: []
                    },
                    mode: 'new'
                });
            }
        }

    }

    createGroup(e) {
        e.preventDefault();

        if (!this.validateGroup(this.state.newGroup)) {
            return;
        }

        this.props.createPostGroup(this.state.newGroup);

        if (this.state.errors) {
            this.props.deleteApiError(['POSTGROUP_LIST', 'POSTGROUP_CREATE', 'POSTGROUP_DELETE', 'POSTGROUP_UPDATE']);
        }
    }

    editGroup(e) {
        let groupId = parseInt(e.currentTarget.dataset.id),
            postGroup = this.props.postgroups.find(({id}) => { return id === groupId; });

        if (postGroup) {
            let editGroup = Utilities.deepClone(postGroup);

            // convert strings to ints for better living
            editGroup.group.map((id, i) => {
                editGroup.group[i] = parseInt(id);
            });

            this.setState({
                editGroup,
                mode: 'edit',
                apiErrors: null,
                validationErrors: null
            });
        }

    }

    confirmGroupEdit() {

        if (!this.validateGroup(this.state.editGroup)) {
            return;
        }

        this.props.updatePostGroup(this.state.editGroup);

        if (this.state.errors) {
            this.props.deleteApiError(['POSTGROUP_LIST', 'POSTGROUP_CREATE', 'POSTGROUP_DELETE', 'POSTGROUP_UPDATE']);
        }

    }

    deleteGroup(e) {
        let id = parseInt(e.currentTarget.dataset.id);

        let modal = (
            <DeleteModal
                modalCopy={"Are you sure you want to remove this Post Group?"}
                cancelAction={() => {
                    this.props.closeAllModals();
                }}
                confirmAction={() => {
                    if (this.state.editGroup.id === id) {
                        this.setState({
                            editGroup: {
                                id: 0,
                                name: '',
                                group: []
                            },
                            mode: 'new'
                        });
                    }
                    this.props.deletePostGroup(id);
                    this.props.closeAllModals();
                }}
                confirmLabel="Remove Group"/>
        );

        this.props.addModal(modal);

        if (this.state.errors) {
            this.props.deleteApiError(['POSTGROUP_LIST', 'POSTGROUP_CREATE', 'POSTGROUP_DELETE', 'POSTGROUP_UPDATE']);
        }
    }

    cancelEdits(e) {
        e.preventDefault();

        if (this.state.mode === 'new') {
            this.setState({
                newGroup: {
                    name: '',
                    group: []
                },
                apiErrors: null,
                validationErrors: null
            });
        } else {
            this.setState({
                editGroup: {
                    id: 0,
                    name: '',
                    group: []
                },
                mode: 'new',
                apiErrors: null,
                validationErrors: null
            });
        }
    }

    validateGroup(group) {
        let validationErrors = [];
        if (_.isEmpty(group.name)) {
            validationErrors.push({'name': 'A group name is required.'});
        }
        if (!group.group.length) {
            validationErrors.push({'group': 'At least one social should be selected for your group.'});
        }

        if (validationErrors.length) {
            this.setState({
                validationErrors
            });
            return false;
        } else {
            if (this.state.validationErrors) {
                this.setState({
                    validationErrors: null
                });
            }
        }

        return true;
    }

    onSocialClick(e) {
        let id = parseInt(e.currentTarget.dataset.id);

        if (id) {
            let nextGroupState = (this.state.mode === 'new') ? Utilities.deepClone(this.state.newGroup) : Utilities.deepClone(this.state.editGroup);

            if (nextGroupState.group.indexOf(id) !== -1) {
                nextGroupState.group.splice(nextGroupState.group.indexOf(id), 1);
            } else {
                nextGroupState.group.push(id);
            }

            if (this.state.mode === 'new') {
                this.setState({
                    newGroup: nextGroupState
                });
            } else {
                this.setState({
                    editGroup: nextGroupState
                });
            }
        }
    }

    filterCallback(e, key) {

		if (key === '') {
			this.props.clearFilter('socials');
		} else {
			this.props.filterStore('socials', ['psID'], key, true);
		}

	}

    searchCallback(e, search) {

		if (this.state.serviceId) {
			this.props.filterStore('socials', ['psID'], this.props.social.psId.toString(), true);
			this.props.filterStore('socials', ['name'], search, false, true);
		} else {
			this.props.filterStore('socials', ['name'], search);
		}

    }

    render() {
        let editorLabel = 'Create New Posting Group',
            buttonLabel = 'Create Group',
            errors = null,
            selectedSocials = this.state.newGroup.group,
            action = this.createGroup,
            keys = [],
            field = "newGroup.name",
            name = this.state.newGroup.name,
            helpLink = null;

        if (this.state.errors || this.state.validationErrors) {
            let errorList = [];
            if (this.state.validationErrors) {
                this.state.validationErrors.map((error) => {
                    keys = Object.keys(error);
                    keys.map((key) => {
                        errorList.push(error[key]);
                    });
                })
            }

            if (this.state.apiErrors) {
                if (this.state.apiErrors.error !== undefined && this.state.apiErrors.errors.validation !== undefined) {
                    keys = Object.keys(this.state.apiErrors.errors.validation);
                    keys.map((key) => {
                        errorList.push(this.state.apiErrors.errors.validation[key]);
                    })
                }
            }

            if (errorList.length) {
                errors = (
                    <div className="post-group-errors">
                        {errorList.map((error, i) => {
                            return (
                                <p key={i}><i className="icon ion-android-alert"></i>{error}</p>
                            );
                        })}
                    </div>
                );
            }

        }

        if (this.state.mode === 'edit') {
            editorLabel = `Save ${this.state.editGroup.name}`;
            buttonLabel = 'Save Group';
            action = this.confirmGroupEdit;
            selectedSocials = this.state.editGroup.group;
            field = "editGroup.name",
            name = this.state.editGroup.name;
        }

        if (this.state.loading === false && this.props.app.hasNoData.POSTGROUP_LIST) {
            helpLink = (
                <div className="post-group-help">
                    <a target="_blank" href="https://support.dlvrit.com/hc/en-us/articles/217957697-How-do-I-Create-Posting-Groups-">What's a post group?</a>
                </div>
            );
        }

        return (
			<Content>
                {this.state.loading ? (
                    <Loading/>
                ) : (
                    <div>
                        {(!this.state.loading && this.props.postgroups.length) ? (
                            <div className="post-groups list">
                                <div className="post-group-header">
                                    Your Posting Groups
                                </div>
                                <div className="post-group-columns">
                                    {this.props.postgroups.map((postgroup) => {
                                        return (
                                            <div key={postgroup.id} className="post-group-item">
                                                <div className="group-name">{postgroup.name}</div>
                                                <div className="group-actions">
                                                    <div className="group-action edit" role="button" aria-label="Edit Group" onClick={this.editGroup} data-id={postgroup.id}>
                                                        <i className="fa fa-pencil"></i>
                                                    </div>
                                                    <div className="group-action delete" role="button" aria-label="Delete Group" onClick={this.deleteGroup} data-id={postgroup.id}>
                                                        <i className="fa fa-trash-o"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : null}
                        {this.props.app.hasNoData.SOCIAL_LIST ? (
                            <div className="post-group-empty">
                                You'll need to <a href="/config/socials">connect your socials</a> before creating a posting group.
                            </div>
                        ) : (
                            <div className="post-groups editor">
                                <div className="post-group-header">
                                    {editorLabel}
                                </div>
                                {errors}
                                <div className="post-group-name-wrapper">
                                    <div className="post-group-name-label">Posting Group Name <span className="required">*</span></div>
                                    <UncontrolledTextInput
                                        className={`text-input medium`}
                                        value={name}
                                        placeholder="Group Name"
                                        onChange={FormUtilityMixin.requestChange.bind(this)}
                                        data-field={field}/>
                                    {helpLink}
                                </div>
                                <div>
                                    <div className={`socials-list`}>
                                        <SocialSelection
                                            {...this.props}
                                            socials={this.props.socials}
                                            selectedSocials={selectedSocials}
                                            context="post-groups"
                                            socialClickHandler={this.onSocialClick}
                                            filterHandler={this.filterCallback}
                                            searchHandler={this.searchCallback}
                                            toggleListHeight={true}/>
                                    </div>
                                    <div className="post-group-actions">
                                        <div className="btn-secondary fixed" role="button" aria-label="cancel edits" onClick={this.cancelEdits}>
                                            cancel
                                        </div>
                                        <button className="btn-primary active fixed" onClick={action}>
                                            {buttonLabel}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Content>
		);
    }
}

PostingGroups.displayName = "PostingGroups";

const enhance = compose(
    ComponentWithContext,
    PostGroupProvider
);

export default enhance(PostingGroups);
